import { BudgetPurpose } from '../../graphql/generated';
import styleguide from '../../styleguide';
import { BUDGET_PURPOSE_COLOR_MAP } from './colors';

export interface BudgetProgressBarProps {
    incomeAmount: number;
    currentAmount: number;
    otherAmount: number;
    budgetPurpose: Exclude<BudgetPurpose, 'income'>;
}

export const OVERAGE_COLOR = styleguide.colors.orangeBright;

export const useBudgetProgressBarProps = ({
    incomeAmount,
    otherAmount,
    currentAmount,
    budgetPurpose,
}: BudgetProgressBarProps) => {
    const otherPercentage = Math.min((otherAmount / incomeAmount) * 100, 100);
    const currentPercentage = Math.min(
        (currentAmount / incomeAmount) * 100,
        100 - otherPercentage
    );
    const totalPercentage = currentPercentage + otherPercentage;
    const remainingAmount = incomeAmount - (currentAmount + otherAmount);
    const color = BUDGET_PURPOSE_COLOR_MAP[budgetPurpose];

    return {
        otherPercentage,
        currentPercentage,
        totalPercentage,
        remainingAmount,
        color,
    };
};
